"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _commonCta = require("@mmc/common-cta");
var _configurator = _interopRequireDefault(require("../styles/configurator.css"));
var _path, _path2, _g, _WarningIcon;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var WarningIcon = function WarningIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "85",
    height: "84",
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _path || (_path = /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2619 7.00049L4.94836 77.48H79.5719L42.2619 7.00049ZM42.2619 21.963L67.9484 70.4835H16.5719L42.2619 21.963ZM38.7234 52.4998H45.7234V38.4998H38.7234V52.4998ZM45.7234 62.9998H38.7234V55.9998H45.7234V62.9998Z",
    fill: "black"
  })), /*#__PURE__*/_react["default"].createElement("mask", {
    id: "mask0_4710_9601",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "4",
    y: "7",
    width: "76",
    height: "71"
  }, _path2 || (_path2 = /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2619 7.00049L4.94836 77.48H79.5719L42.2619 7.00049ZM42.2619 21.963L67.9484 70.4835H16.5719L42.2619 21.963ZM38.7234 52.4998H45.7234V38.4998H38.7234V52.4998ZM45.7234 62.9998H38.7234V55.9998H45.7234V62.9998Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/_react["default"].createElement("g", {
    mask: "url(#mask0_4710_9601)"
  })));
};
var ConfiguratorError = function ConfiguratorError(_ref) {
  var theme = _ref.theme,
    configuratorErrorTitle = _ref.configuratorErrorTitle,
    configuratorErrorDescription = _ref.configuratorErrorDescription,
    refreshPageCtaLabel = _ref.refreshPageCtaLabel,
    restartToolCtaLabel = _ref.restartToolCtaLabel,
    cancelRestartCtaLabel = _ref.cancelRestartCtaLabel,
    confirmRestartCtaLabel = _ref.confirmRestartCtaLabel,
    restartToolTitle = _ref.restartToolTitle,
    restartToolDescription = _ref.restartToolDescription,
    restartTool = _ref.restartTool;
  var _useState = (0, _react.useState)(false),
    showSecondaryState = _useState[0],
    setShowSecondaryState = _useState[1];
  (0, _react.useEffect)(function () {
    // Scroll to the top of the body
    window.scrollTo(0, 0);
    // prevent body scrolling but allow overlay scrolling
    var _document = document,
      body = _document.body;
    body.style.overflow = 'hidden';
    // Remove the style when the component unmounts
    return function () {
      body.style.overflow = 'unset';
    };
  }, []);
  var handleRefreshPage = function handleRefreshPage() {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };
  var handleConfirmRestart = function handleConfirmRestart() {
    restartTool();
  };
  var getDefaultState = function getDefaultState() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _configurator["default"].configuratorErrorSummary
    }, /*#__PURE__*/_react["default"].createElement("h2", {
      className: theme.headingFive + " " + _configurator["default"].errorTitle
    }, configuratorErrorTitle), /*#__PURE__*/_react["default"].createElement("p", {
      className: "" + theme.bodyCopy
    }, configuratorErrorDescription), /*#__PURE__*/_react["default"].createElement("p", {
      className: "" + theme.bodyCopy
    }, restartToolDescription), /*#__PURE__*/_react["default"].createElement("div", {
      className: _configurator["default"].errorCtaWrapper
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      data: {
        ctaType: 'button',
        label: refreshPageCtaLabel,
        priority: 'high'
      },
      clickEvent: handleRefreshPage,
      theme: theme
    }), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      data: {
        ctaType: 'button',
        label: restartToolCtaLabel,
        priority: 'medium'
      },
      clickEvent: function clickEvent() {
        return setShowSecondaryState(true);
      },
      theme: theme
    })));
  };
  var getSecondaryState = function getSecondaryState() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _configurator["default"].configuratorErrorSummary
    }, /*#__PURE__*/_react["default"].createElement("h2", {
      className: theme.headingFive + " " + _configurator["default"].errorTitle
    }, restartToolTitle), /*#__PURE__*/_react["default"].createElement("p", {
      className: "" + theme.bodyCopy
    }, restartToolDescription), /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.bodyCopy + " " + _configurator["default"].errorDescriptionDummy
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _configurator["default"].errorCtaWrapper
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      data: {
        ctaType: 'button',
        label: cancelRestartCtaLabel,
        priority: 'low'
      },
      clickEvent: function clickEvent() {
        return setShowSecondaryState(false);
      },
      theme: theme
    }), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      data: {
        ctaType: 'button',
        label: confirmRestartCtaLabel,
        priority: 'critical'
      },
      clickEvent: handleConfirmRestart,
      theme: theme
    })));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _configurator["default"].configuratorErrorWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + _configurator["default"].configuratorError
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _configurator["default"].warningIcon
  }, _WarningIcon || (_WarningIcon = /*#__PURE__*/_react["default"].createElement(WarningIcon, null))), showSecondaryState ? getSecondaryState() : getDefaultState()));
};
var _default = exports["default"] = ConfiguratorError;